import { makeAutoObservable } from 'mobx';
import { AutomationPropagateMetadataRelationship } from '../../api/types/models/automation/automationPropagateMetadata';
import { isValidEnumValue } from '../../utils/enumUtils';
import type { PropagateMetadataSettings } from './types';

export class PropagateBlockStore {
	propagateSettings: PropagateMetadataSettings;

	constructor(initialPropagateSettings: PropagateMetadataSettings) {
		makeAutoObservable(this, {}, { autoBind: true });

		this.propagateSettings = initialPropagateSettings;
	}

	setOverrideExistingProperties(overrideExistingProperties: boolean) {
		this.propagateSettings = {
			...this.propagateSettings,
			overrideExistingProperties,
		};
	}

	addProperties(properties: string[]) {
		this.propagateSettings = {
			...this.propagateSettings,
			properties,
		};
	}

	setPropagateTo(propagateTo: string | null) {
		if (
			propagateTo &&
			isValidEnumValue(AutomationPropagateMetadataRelationship, propagateTo)
		) {
			this.propagateSettings = {
				...this.propagateSettings,
				propagateTo,
			};
		} else {
			this.propagateSettings = {
				...this.propagateSettings,
				propagateTo: AutomationPropagateMetadataRelationship.CHILDREN,
			};
		}
	}

	setLevel(level: string | null) {
		if (level) {
			this.propagateSettings = {
				...this.propagateSettings,
				level,
			};
		} else {
			this.propagateSettings = {
				...this.propagateSettings,
				level: '1',
			};
		}
	}
}
